import './layout.scss';

import { useState } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Outlet, useLocation } from 'react-router';

import MainLoader from '@/shared/ui/main-loader';
import { ErrorFallback } from '@/shared/widgets';
import { useAppSelector } from '@/store';

import ConnectionBanner from './entities/connection-banner';
import { BottomTabBar, Header, NavDrawer } from './widgets';

const Layout: React.FC = () => {
  const location = useLocation();
  const [isNavOpen, setIsNavOpen] = useState(false);
  const { layoutCount, layoutBlurCount } = useAppSelector(
    (state) => state.loading
  );

  const openNav = (): void => setIsNavOpen(true);
  const closeNav = (): void => setIsNavOpen(false);

  return (
    <div className="layout">
      <Header onOpenNav={openNav} />

      <main className="layout__main">
        {(layoutCount > 0 || layoutBlurCount > 0) && (
          <MainLoader layout blur={layoutBlurCount > 0} />
        )}
        <ConnectionBanner />
        <ErrorBoundary
          FallbackComponent={ErrorFallback}
          resetKeys={[location.pathname]}
        >
          <Outlet />
        </ErrorBoundary>
      </main>

      <BottomTabBar onOpenNav={openNav} />
      <NavDrawer open={isNavOpen} onClose={closeNav} />
    </div>
  );
};

export default Layout;
